import { Link } from "react-router-dom";
import { scrollToId, InstagramLink, useNavItems } from "./Nav";
import { LogoMark } from "./Logo";
import { useLang } from "@/lib/i18n";

export const Footer = () => {
  const { t } = useLang();
  const NAV = useNavItems();
  return (
  <footer data-testid="site-footer" className="border-t border-[var(--line)] px-5 sm:px-8 lg:px-12 pt-16 pb-8 overflow-hidden">
    <div className="flex flex-col md:flex-row justify-between gap-10">
      <div className="flex items-start gap-4">
        <LogoMark className="w-10 h-10" />
        <p className="max-w-xs text-sm text-[var(--muted)]">{t("footer.tagline")}</p>
      </div>
      <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
        {NAV.map((n) => (
          <button key={n.id} data-testid={`footer-link-${n.id}`} onClick={() => scrollToId(n.id)}
            className="font-mono text-xs uppercase tracking-[0.2em] hover:text-[var(--signal)] transition-colors">{n.label}</button>
        ))}
        <InstagramLink testid="footer-instagram-link" />
      </div>
    </div>
    <p aria-hidden="true" className="font-display font-black uppercase leading-[0.8] text-[22vw] mt-14 text-[var(--ink-3)] select-none whitespace-nowrap">A.R.R.O.W</p>
    <div className="mt-6 flex flex-col sm:flex-row justify-between gap-3 font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--muted)]">
      <span>© 2026 A.R.R.O.W Development Group</span>
      <Link data-testid="footer-admin-link" to="/admin" className="hover:text-[var(--bone)]">{t("footer.staff")}</Link>
    </div>
  </footer>
  );
};
